import { Injectable } from '@angular/core';
import { FavouriteListService } from './favourite-list.service';

export const FAVOURITE_ALBUMS_MAX = 1000;

/** A saved album as stored on the server. */
export interface FavouriteAlbum {
  id: string;
  name: string;
  artists: Array<{ id: string; name: string }>;
  cover: string;
  release_date: string;
  fans: number;
  genre_id: number;
  nb_tracks: number;
  addedAt?: string;
}

/** The shape the album grid renders (same as chart albums). */
export function toGridAlbum(f: FavouriteAlbum): any {
  return {
    id: f.id,
    name: f.name,
    images: [{ url: f.cover }],
    release_date: f.release_date,
    total_tracks: f.nb_tracks,
    artists: f.artists,
    fans: f.fans,
    genre_id: f.genre_id
  };
}

@Injectable({ providedIn: 'root' })
export class FavouriteAlbumsService extends FavouriteListService<FavouriteAlbum> {
  protected readonly path = 'favourite-albums';
  protected readonly noun = 'Favourite Albums';
  readonly max = FAVOURITE_ALBUMS_MAX;

  /** The full saved list once loaded (the Favourite Albums page), otherwise null. */
  readonly albums = this.items;
}
